import cls from 'classnames';
import { TooltipControl } from 'src/components/base/Tooltip';
import { hasCatchLocation } from 'src/utils/catches';
import locationIcon from 'assets/svg/catch-location.svg';
import locationNoneIcon from 'assets/svg/catch-location-none.svg';
import photosIcon from 'assets/svg/catch-photos.svg';
import photosNoneIcon from 'assets/svg/catch-photos-none.svg';
import classes from './Catches.module.scss';

export const CatchIndicators = ({ item }) => {
  const hasLocation = hasCatchLocation(item);
  const photoCount = Number(item?.images_count) || 0;
  const hasPhotos = photoCount > 0;

  const locationTooltip = hasLocation ? (item.coordinates || __('Location available')) : __('No location');
  const photosTooltip = hasPhotos
    ? __('{count} photos').replace('{count}', photoCount)
    : __('No photos');

  return (
    <div className={classes.mapPhotos}>
      <TooltipControl tooltip={locationTooltip} placement="top">
        <span className={cls(classes.indicator, { [classes.indicatorActive]: hasLocation })}>
          <img src={hasLocation ? locationIcon : locationNoneIcon} alt="" aria-hidden="true" />
        </span>
      </TooltipControl>
      <TooltipControl tooltip={photosTooltip} placement="top">
        <span className={cls(classes.indicator, { [classes.indicatorActive]: hasPhotos })}>
          <img src={hasPhotos ? photosIcon : photosNoneIcon} alt="" aria-hidden="true" />
        </span>
      </TooltipControl>
    </div>
  );
};
